import { render } from "./Prospects.vue?vue&type=template&id=d7726b56&scoped=true"
import script from "./Prospects.vue?vue&type=script&lang=js"
export * from "./Prospects.vue?vue&type=script&lang=js"

import "./Prospects.vue?vue&type=style&index=0&id=d7726b56&lang=scss&scoped=true"
import "./Prospects.vue?vue&type=style&index=1&id=d7726b56&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7726b56"]])

export default __exports__